import { render, staticRenderFns } from "./FinishedOrders.vue?vue&type=template&id=4fd494f8&scoped=true"
import script from "./FinishedOrders.vue?vue&type=script&lang=js"
export * from "./FinishedOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd494f8",
  null
  
)

export default component.exports